import { render, staticRenderFns } from "./LomIndividual.vue?vue&type=template&id=4a80ca7a"
import script from "./LomIndividual.vue?vue&type=script&lang=js"
export * from "./LomIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports